export default "__VITE_ASSET__1a1be9d9__"